<template>
  <list ref="list">
    <el-table-column slot="column" prop="CreateTime" label="更新时间" min-width="140" />
    <el-button-group slot="operate">
      <el-button v-action="'/api/ProductManage/Stock/Export'" size="small" type="primary" icon="el-icon-upload2" @click="importData">导入</el-button>
      <el-button v-action="'/api/ProductManage/Stock/Import'" size="small" type="primary" icon="el-icon-download" @click="exportData">导出</el-button>
      <el-button v-action="'/api/ProductManage/Stock/Delete'" size="small" type="danger" icon="el-icon-delete" @click="onDelete">清空</el-button>
    </el-button-group>
  </list>
</template>


<script>
import importpage from './import.vue'
export default {
  components: { list: () => import("./list.vue") },
  methods: {
    //清空数据
    onDelete () {
      this.$confirm("此操作将永久删除选中的授权数据, 是否继续?", "清空数据", {
        center: true,
      }).then(() => {
        this.$apis.product.stock.delete().then((res) => {
          this.onSearch()
          this.$message({
            message: res || "执行成功！",
            type: "success",
          })
        })
      })
    },
    //导入数据
    importData () {
      this.$layer.iframe({
        title: '导入数据',
        area: ['1000px', '800px'],
        content: {
          content: importpage,
          parent: this,
          data: {
            callback: () => {
              this.loadData()
            }
          }
        }
      })
    },
    //导出数据
    exportData () {
      this.loading = true
      this.$apis.product.stock.export(this.queryParams).then((res) => {
        console.log(res)
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
